module.exports = __webpack_public_path__ + "img/Ausflug_2019.1883e3a7.jpg";